<template>
    <div>
        <Head title="Recent Token Activity | Wallet" />

        <heading>
            <template #heading>
                <Link :href="route('wallet.show')" class="flex items-center hover:text-indigo-600 space-x-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12" />
                    </svg>
                    <span>Wallet</span>
                </Link>
            </template>
        </heading>

        <div class="min-h-screen lg:col-span-8">
            <recent-token-activity :activity="tokenActivity" />
        </div>
    </div>
</template>

<script>
import Heading from "@/Components/Heading"
import RecentTokenActivity from "@/Components/Wallet/RecentTokenActivity"
import AppLayout from "@/Layouts/AppLayout"

export default {
    components: { RecentTokenActivity, Heading },

    layout: AppLayout,

    props: {
        tokenActivity: {
            required: true,
        },
    },
}
</script>
